function toutou_xy_vents(myJson,zoom,ctx=undefined){

  //Argument optionel
  if (zoom!=null){
    var my_zoom=zoom;
  } else {
    var my_zoom=0;
  }

  // Donnees de MySQL
  var ni=myJson.hhh.length;
  var nk=myJson.levs.length;

  var force    = new Array(ni);
  var dir      = new Array(ni);
  var gust     = new Array(ni);
  var hhh      = new Array(ni);
  var time_label=new Array(ni);
  var tempo    = new Array(ni);
  var aaaammjj = myJson.aaaammjj;
  var hh       = myJson.hh;
  var deg2rad  = Math.PI/180.;
  var datev     = dateo;
  var my_fonts = new Toutou_Fonts();
  var tr       = new Toutou_Transform();
  var nptcub   = 9;

  unitJson=toutou_get_option('unite_vent');

  for (var i=0; i < ni; i++) {
    force[i] = new Array(nk);
    dir[i]   = new Array(nk);
    for (var k = 0; k < nk; k++) {
      ind=nk*i+k;
      force[i][k] = Math.floor(myJson.data1[ind]/1000.);
        dir[i][k] = myJson.data1[ind] - force[i][k]*1000;
      force[i][k] = force[i][k]/10.*unitJson.conv;
    }
    gust[i]=myJson.data5[i]*unitJson.conv;
    hhh[i]=myJson.hhh[i];
  }

  pointsData['vents'] = [];
  
  // Espace autour de la boite du graphique en %
  var pil_w=.08;
  var pil_e=.01;
  var pil_s=.2;
  var pil_n=.15;

  if(ctx == undefined) ctx=set_canvas('toutou_xy_vents');
  
  tr.xrange(my_zoom,hhh);

  tr.ymin=0.;
  if(unitJson.unite == 'noeuds'){
    tr.ymax=50.;
    inc=5;    
  }else if(unitJson.unite == 'mph'){ 
    tr.ymax=50.; 
    inc=5;  
  }else if(unitJson.unite == 'km/h'){
    tr.ymax=100.;
    inc=10;   
  }else if(unitJson.unite == 'm/s'){
    tr.ymax=24.;
    inc=2;      
  }
    
  dimx=tr.xmax-tr.xmin;
  tr.xmin=tr.xmin-.04*dimx;
  tr.xmax=tr.xmax+.04*dimx;
  
  tr.pix_margeg=Math.round((   pil_w)*gxsize)+.5;
  tr.pix_marged=Math.round((1.-pil_e)*gxsize)+.5;
  tr.pix_margeh=Math.round((   pil_n)*gysize)+.5;
  tr.pix_margeb=Math.round((1.-pil_s)*gysize)+.5;      
  
  tr.init();

  pointsData['vents_params'] = { xmin_pix: tr.d2px(tr.xmin), xmax_pix: tr.d2px(tr.xmax),
				 ymin_pix: tr.d2py(tr.ymin), ymax_pix: tr.d2py(tr.ymax),
				 wd_col: '#00f', dir_col: 'none', gust_col:'red'};
  
  
  ctx.fillStyle = '#FFF';
  ctx.fillRect(0, 0, gxsize,gysize);

  tr.draw_model_zones(ctx, my_fonts, hhh, myJson.modele);

  // Titre principal
  ctx.font = my_fonts.principal;
  ctx.fillStyle = "#33A"; 
  ctx.textAlign="center";
  ctx.textBaseline="top";
  ctx.fillText('Date de départ : '+toutou_xy_titre_principal(dateo),.5*(tr.xmax_pix+tr.xmin_pix),0); 
  ctx.restore(); 
  
  // Titre secondaire
  ctx.font = my_fonts.legende;
  ctx.fillStyle = pointsData['vents_params'].wd_col
  ctx.textAlign="left";
  ctx.textBaseline="bottom";
  ctx.fillText('Vents en '+unitJson.unite,tr.xmin_pix,tr.ymax_pix-2); 
  
  // xticks
  tr.xticks_jours(datev,hhh,ctx,my_fonts,my_zoom,{time_label});
  
  // yticks
  ctx.beginPath();
  ctx.font = my_fonts.axis;
  ctx.fillStyle = "Black";
  nj=(Math.floor(tr.ymax)-Math.ceil(tr.ymin)+1);
  ctx.strokeStyle = 'black';      
  ctx.textAlign="right";
  ctx.textBaseline="middle";
  xx=Math.round(tr.xmin_pix-.01*(tr.xmax_pix-tr.xmin_pix))+.5;
  for (var i=0; i < nj; i=i+inc) {	
    yy=Math.round(tr.d2py(Math.ceil(tr.ymin)+i))+.5;
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(xx,yy);
    ctx.fillText((Math.ceil(tr.ymin)+i)+' ',xx,yy);
  }
  ctx.stroke();
  
  // Lignes grises
  ctx.strokeStyle = '#bbb';
  for (var i=0; i < nj; i=i+inc) {
    val=Math.ceil(tr.ymin)+i;
    yy=Math.round(tr.d2py(val))+.5;
    ctx.beginPath();
    ctx.moveTo(tr.xmin_pix,yy);
    ctx.lineTo(tr.xmax_pix,yy);
    ctx.stroke();
  }
  
    ctx.stroke();
    // Tracer la force du vent
    for (var i=tr.xind_min; i <= tr.xind_max; i++) {
	tempo[i]=force[i][0]
    }
    res_force=toutout_cubic_mono(hhh,tempo,nptcub);
    ctx.beginPath();
  ctx.strokeStyle =  pointsData['vents_params'].wd_col;
    for(i=tr.xind_min*(nptcub+1);i<=tr.xind_max*(nptcub+1);i++) {
	ctx.lineTo(tr.d2px(res_force.x[i]),tr.d2py(res_force.y[i]));
    }
    ctx.stroke();
    // Tracer les boites pour la force du vent
    ctx.beginPath();
    ctx.fillStyle = pointsData['vents_params'].wd_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]),tr.d2py(force[tr.xind_min][0]));    
    for (var i=tr.xind_min; i <= tr.xind_max; i++) {
	xx=tr.d2px(hhh[i]);
	yy=tr.d2py(force[i][0]);
        ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
        pointsData['vents'].push({x:xx, y:yy, tl:time_label[i], wd:force[i][0], dir:dir[i][0], gust:gust[i]});
    }
    ctx.stroke();
    ctx.fillStyle = pointsData['vents_params'].gust_col;
    ctx.strokeStyle = pointsData['vents_params'].gust_col;
    // Tracer les rafales de Brasseur
    for (var i=tr.xind_min; i <= tr.xind_max; i++) {
      tempo[i]=gust[i]
      if(Math.round(gust[i]) > Math.round(force[i][0])){
	xx=tr.d2px(hhh[i]);
	yy=tr.d2py(gust[i]);
	ctx.fillRect(xx-tr.dd,yy-tr.dd,2*tr.dd,2*tr.dd);
	pointsData['vents'].push({x:xx, y:yy, tl:time_label[i], wd:force[i][0], dir:dir[i][0], gust:gust[i]});
      }
    }
    res_gust=toutout_cubic_mono(hhh,tempo,nptcub);
    ctx.beginPath();
    for(i=tr.xind_min*(nptcub+1);i<=tr.xind_max*(nptcub+1);i++) {
      ctx.lineTo(tr.d2px(res_gust.x[i]),tr.d2py(Math.max(res_gust.y[i],res_force.y[i])));
    }
    ctx.stroke();
    // Tracer les trous avec rafale de Brasseur
  //ctx.beginPath();
  //ctx.strokeStyle = 'green';
  //  for(i=tr.xind_min*(nptcub+1);i<=tr.xind_max*(nptcub+1);i++) {
  //    ctx.lineTo(tr.d2px(res_gust.x[i]),tr.d2py(Math.max(0.,Math.min(2.*res_force.y[i]-res_gust.y[i],res_force.y[i]))));
  //  }
  //  ctx.stroke();
  // Tracer les fleches de direction
  dd=.5*(tr.xmax_pix-tr.xmin_pix)/ni;  
  ctx.fillStyle = 'red'; 
  ctx.strokeStyle = 'red'; 
  yy_pix=tr.ymin_pix+.9*(tr.ymax_pix-tr.ymin_pix);
  pix_dl=dd; // Longueur des fleches en pixel 
  for (var i=tr.xind_min; i <= tr.xind_max; i++) {
    if(dir[i][0]<990){
      my_rad=deg2rad*dir[i][0];
      // Corps de la fleche
      pix_fx = Math.round( Math.sin(my_rad) * pix_dl ); 
      pix_fy = Math.round( Math.cos(my_rad) * pix_dl );
      ctx.beginPath();
      xx_pix=tr.d2px(hhh[i]);
      pointsData['vents'].push({x:xx_pix, y:yy_pix, tl:time_label[i], wd:force[i][0], dir:dir[i][0], gust:gust[i]});
      ctx.moveTo(xx_pix+pix_fx,yy_pix-pix_fy);
      ctx.lineTo(xx_pix-pix_fx,yy_pix+pix_fy);
      ctx.stroke(); 
      
      // Pointe de la fleche
      //ctx.beginPath();
      ctx.moveTo(xx_pix-pix_fx,yy_pix+pix_fy); 
      // Pointe de la fleche cote gauche 
      px_pix = Math.round( Math.sin(my_rad+1.3) *.4* pix_dl ); 
      py_pix = Math.round( Math.cos(my_rad+1.3) *.4* pix_dl ); 
      ctx.lineTo(xx_pix-px_pix,yy_pix+py_pix);
      
      // Pointe de la fleche cote droit 
      px_pix = Math.round( Math.sin(my_rad-1.3) *.4* pix_dl ); 
      py_pix = Math.round( Math.cos(my_rad-1.3) *.4* pix_dl ); 
      ctx.lineTo(xx_pix-px_pix,yy_pix+py_pix);
      ctx.closePath();
      ctx.fill();
      
    }
  }
}
